import { AuthenticationStorage } from '@src/common/AuthenticationStorage';
import { Client } from '@src/common/services/Client';
import Config from '@src/config/Config';
import axios from 'axios';

const TIMEOUT_IN_MILLIS = 60000;

const api = axios.create({
  baseURL: Config.VITE_API_URL,
  timeout: TIMEOUT_IN_MILLIS,
  headers: { Accept: 'application/json' },
  withCredentials: true,
  maxRedirects: 0,
});

api.interceptors.request.use(
  (request) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      request.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const response = await Client.get('/refresh', {
          withCredentials: true,
        });
        const { accessToken } = response.data;
        AuthenticationStorage.setAccessToken(accessToken);
        api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        AuthenticationStorage.removeAccessToken();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  },
);

export const AuthenticatedClient = api;
